/* Collection PLP — filter sidebar, hide/show, auto-submit */
(() => {
  const layout = document.querySelector('[data-collection-layout]');
  if (!layout) return;

  const STORAGE_KEY = 'ghalia-collection-filters-hidden';
  const hideBtn = layout.querySelector('[data-collection-filters-hide]');
  const showBtn = layout.querySelector('[data-collection-filters-show]');

  const setFiltersHidden = (hidden) => {
    layout.classList.toggle('is-filters-hidden', hidden);
    if (hideBtn) hideBtn.hidden = hidden;
    if (showBtn) showBtn.hidden = !hidden;
    try {
      if (hidden) sessionStorage.setItem(STORAGE_KEY, '1');
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) { /* noop */ }
  };

  if (window.matchMedia('(min-width: 1025px)').matches) {
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') setFiltersHidden(true);
    } catch (_) { /* noop */ }
  }

  hideBtn?.addEventListener('click', () => setFiltersHidden(true));
  showBtn?.addEventListener('click', () => setFiltersHidden(false));

  /* Pill tracks — scroll active pill into view (mobile / tablet) */
  const alignPillTrack = (track) => {
    if (!track || !window.matchMedia('(max-width: 1024px)').matches) return;
    const active = track.querySelector('.filter-pill.is-active');
    if (!active) return;
    const run = () => {
      try {
        active.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'instant' });
      } catch (_) {
        const trackRect = track.getBoundingClientRect();
        const pillRect = active.getBoundingClientRect();
        const delta = pillRect.left - trackRect.left - (trackRect.width - pillRect.width) * 0.5;
        track.scrollLeft += delta;
      }
    };
    if (track.scrollWidth > track.clientWidth) {
      requestAnimationFrame(run);
    }
  };

  document.querySelectorAll('[data-collection-pill-track]').forEach((track) => {
    alignPillTrack(track);
    window.addEventListener('resize', () => alignPillTrack(track), { passive: true });
  });
})();
